import { getSuggestions, type MailSuggestionContext } from '../utils/getSuggestions';
import { isFeatureEnabled } from 'owa-feature-flags';

export const shouldOmitPopover = (context?: MailSuggestionContext): boolean => {
    return !getSuggestions(context) && !isFeatureEnabled('copilot-dab-mail-3s-sua');
};
